/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Change_VoiceInputs */

const en_common_change_voice = /** @type {(inputs: Common_Change_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change voice`)
};

const es_common_change_voice = /** @type {(inputs: Common_Change_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar voz`)
};

/**
* | output |
* | --- |
* | "Change voice" |
*
* @param {Common_Change_VoiceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_change_voice = /** @type {((inputs?: Common_Change_VoiceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Change_VoiceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_change_voice(inputs)
	return en_common_change_voice(inputs)
});